(function () {
    'use strict';

    var gettext = angular.identity;

    angular.module('app.clubAdmin')
        /* Club Info */
        .constant('pieChartDefaultOptions', {
            tooltips: {
                displayColors: false,
                callbacks: {}
            }
        })
        .constant('membershipLevelChartDefaults', {
            labels: [gettext('Default'), gettext('Bronze'), gettext('Silver'), gettext('Gold')],
            colors: ['#BDBDBD', '#cd7f32', '#C0C0C0', '#FFD700'],
        })
        .constant('membershipStatusChartDefaults', {
            labels: ['Inactive', 'Active'],
            colors: ['#b9c0be', '#a01d26'],
        })
        .constant('totalAccountsChartDefaults', {
            labels: [gettext('Total')],
            colors: ['#a01d26']
        })
        .constant('categoriesChartDefaults', {
            labels: [gettext('Junior Boys'), gettext('Junior Girls'), gettext('Senior Men'), gettext('Senior Women'), gettext('Men'), gettext('Women'), gettext('Staff')],
            colors: [
                '#B22222', // boy
                '#2F4F4F', // girl
                '#F0E68C', // old man
                '#483D8B', // old women
                '#4682B4', // men
                '#B0E0E6', // women
                '#DAA520' // staff                
            ]
        })

        /* Member Roster */
        .constant('defaultMemberRosterPageSize', 10)
        .constant('memberRosterSearchPlaceholder', gettext('Enter "last, first name" or card #.'))

        /* Subgroups */
        .constant('subgroupMemberLookupPageSize', 20)

        /* Stats Dashboard */
        .constant('barChartDefaultOptions', {
            legend: { display: true, position: 'bottom', labels: { boxWidth: 12 } },
            scales: { yAxes: [{ ticks: { beginAtZero: true } }] }
        })
        .constant('scoresPostedChartDefaults', {
            labels: [gettext('This Week'), gettext('Last Week'), gettext('This Season')],
            series: [gettext('Member'), gettext('Guest')],
            colors: ['#aea7a8', '#a01d26'],
        })
        .constant('uniqueGolfersChartDefaults', {
            labels: [gettext('This Week'), gettext('Last Week'), gettext('This Season')],
            series: [gettext('Repeat Golfers'), gettext('1st Time')],
            colors: ['#255ef5', '#25b619'],
        })

        .enumeration('clubMembershipCategory', {
            JuniorBoys: [, gettext('Junior Boys')],
            JuniorGirls: [, gettext('Junior Girls')],
            SeniorMen: [, gettext('Senior Men')],
            SeniorWomen: [, gettext('Senior Women')],
            Men: [, gettext('Men')],
            Women: [, gettext('Women')],
            Staff: [, gettext('Staff')],
        })

        .enumeration('clubContact', {
            ClubManager: [, gettext('Club Manager')],
            HandicapChair: [, gettext('Handicap Chair')],
            MembershipChair: [, gettext('Membership Chair')],
            EventDirector: [, gettext('Event Director')],
            HeadProfessional: [, gettext('Head Professional')],
            HandicapCommitteeMember: [, gettext('Handicap Committee Member')],
            Other: [, gettext('Other')],
            GolfCoach: [, gettext('Golf Coach')],
            Accounting: [, gettext('Accounting')],
            GeneralManager: [, gettext('General Manager')],
            DirectorOfGolf: [, gettext('Director Of Golf')],
            Superintendent: [, gettext('Superintendent')],
            JuniorGolfContact: [, gettext('Junior Golf Contact')],
            Primary: [, gettext('Primary')],
            GolfSchool: [, gettext('Golf School')],
            League: [, gettext('League')],
            MembershipCanidate: [, gettext('Membership Canidate')],
            HeadTeachingPro: [, gettext('Head Teaching Pro')],
            TeachingPro: [, gettext('Teaching Pro')],
            ExecutivePro: [, gettext('Executive Pro')],
            AssistantPro: [, gettext('Assistant Pro')],
            ClubCaptain: [, gettext('Club Captain')],
            ClubPresident: [, gettext('Club President')],
        })

        .constant('expirationFilterList', [
            { value: null, text: 'N/A' },
            { value: 15, text: '15 days' },
            { value: 30, text: '30 days' },
            { value: 45, text: '45 days' },
            { value: 60, text: '60 days' },
            { value: 75, text: '75 days' },
            { value: 90, text: '90 days' }
        ])

        .constant('clubToolsUrl', 'http://www.golfquebec.org{0}/pages.asp?id={1}')

        /* Resources */
        .constant('clubAdminResources', {
            saveClubInfoFailed: gettext('Failed to save club info.'),
            membershipCreditAdjustmentFailed: gettext('Unable to adjust the membership credits for {0}.'),

            activateMemberConfirmation: gettext('Are you sure you want to activate {0}?'),
            activateMemberFailed: gettext('Failed to activate {0}.'),

            activateSelectedConfirmation: gettext('Are you sure you want to activate the {0} selected members?'),
            activateSelectedFailed: gettext('Failed to activate the {0} selected members.'),

            deactivateMemberConfirmation: gettext('Are you sure you want to deactivate {0}?'),
            deactivateMemberFailed: gettext('Failed to deactivate {0}.'),
            deactivateSelectedConfirmation: gettext('Are you sure you want to deactivate the {0} selected members?'),
            deactivateSelectedFailed: gettext('Failed to deactivate the {0} selected members.'),

            cannotRenewMemberNotPrimary: gettext('Active golfers can only be renewed at their primary club.'),
            cannotRenewMemberDisabled: gettext('Golfers can only be renewed within 140 days of their expiration.'),
            cannotRemoveMember: gettext('Golfers can only be removed from a club roster in the final 6-months of their membership. Please contact members@golfcanada.ca or 1-800-263-0009 Ext. 399 if you require a golfer to be removed before that time.'),
            removeMemberConfirmation: gettext('Are you sure you want remove {0} from your roster?\n\n\rThis action will transfer the account to a regional public player group in its current status.'),
            removeMemberFailed: gettext('Failed to remove {0}.'),
            removeSelectedConfirmation: gettext('Are you sure you want remove {0} selected members from your roster?\n\n\rThis action will transfer the account to a regional public player group in its current status'),
            removeSelectedFailed: gettext('Failed to remove the {0} selected members.'),

            renewOrUpgradeInactiveSecondayWithActivePrimaryMemberConfirmation: gettext('Are you sure you want to renew/upgrade {1}? {1} is an inactve secondary member with an active primary membership. {1} will be synced with primary membership.'),
            renewOrUpgradeInactiveSecondayWithInactivePrimaryMemberConfirmation: gettext('Are you sure you want to renew/upgrade {1}? {1} is an inactve secondary member with an inactive primary membership. This club will become the primary membership.'),
            renewOrUpgradeMemberConfirmation: gettext('Are you sure you want to renew/upgrade {1}?'),
            renewOrUpgradeSelectedConfirmation: gettext('Are you sure you want to renew/upgrade the {0} selected members?'),
            renewOrUpgradeMemberFailed: gettext('Failed to renew/upgrade the {0}.'),
            renewOrUpgradeSelectedFailed: gettext('Failed to renew/upgrade the {0} selected members.'),
            insufficientCredit: gettext('This action requires {0} pre-paid gold membership credits.  You have {1} credits remaining.'),
            memberRosterRequestFailed: gettext('Failed to retrieve member roster from server.'),

            saveFacilitySucceeded: gettext('The facility details have been updated.'),
            saveFacilityFailed: gettext('Failed to save facility details.'),

            confirmDeleteSubgroup: gettext('Are you sure you want to delete this subgroup?'),
            deleteSubgroupFailed: gettext('Failed to delete subgroup.'),
            saveSubgroupFailed: gettext('Failed to save subgroup.'),
            confirmRemoveMemberFromSubgroup: gettext('Are you sure you want to remove this member from the subgroup?'),
            removeMemberFromSubgroupFailed: gettext('Failed to remove member from subgroup.'),
            addSubgroupMemberFailed: gettext('Failed to add member to subgroup.'),
            fetchSubgroupMembersFailed: gettext('Failed to retrieve subgroup members.'),

            confirmDeleteContact: gettext('Are you sure you want to remove this club contact?'),
            deleteContactFailed: gettext('Failed to delete club contact.'),
            saveContactFailed: gettext('Failed to save club contact.'),

            confirmVerifyAllContacts: gettext('Are you sure you want to verify all of the contacts for this club?'),
            confirmVerifyContact: gettext('Are you sure you want to verify this club contact?'),
            verifyContactFailed: gettext('Failed to verify club contact.'),
            verifyAllContactsFailed: gettext('Failed to verify club contacts.'),


            reportRetrievalFailed: gettext('Failed to retrieve reports.'),

            memberAddSucceeded: gettext('{0} {1} has been added {2}.'),
            memberAddFailed: gettext('Failed to add {0} {1} to {2}.'),

            transactionLogRequestFailed: gettext('Failed to retrieve transaction log from server.'),
            teeTimeComparisonRequestFailed: gettext('Failed to retrieve tee time comparison from server.'),
            handicapReviewRequestFailed: gettext('Failed to retrieve handicap review data.')
        });
})();
